import { Editor } from 'slate'

import { isMarkActive } from './isMarkActive.js'

export function toggleMark (editor, format) {
  const isActive = isMarkActive(editor, format)

  if (isActive) {
    Editor.removeMark(editor, format)
    return
  }

  Editor.addMark(editor, format, true)
}
